import { SettingsLayout } from 'modules/settingsContainer/SettingsLayout';
import { ViewTab } from 'modules/visualisations/Text/settings/ViewTab';
import { BackgroundTab } from '../BackgroundTab';

export const TextMainSettings = () => {
  return <SettingsLayout ViewComponent={ViewTab} BackgroundComponent={BackgroundTab} />;
};
